<template>
  <q-btn
    flat
    stack
    no-caps
    dense
    align="left"
    class="stacked-btn"
    :class="{'separated': separator}"
    :size="size"
  >
    <q-avatar
      :size="bubble ? '46px' : size"
      :color="bubbleColor"
      :text-color="iconColor"
      class="shadow-2"
    >
      <q-icon
        :name="icon"
        :size="bubble ? '24px' : undefined"
      />
    </q-avatar>
    <q-item-label
      v-if="label || !!$slots.default"
      class="stacked-btn-label"
      :lines="2"
    >
      {{ label }}

      <slot />
    </q-item-label>
  </q-btn>
</template>

<script>
/**
 * StackedBtn works in a similar fashion to typical QBtn, however label is underneath the icon, and the
 *  icon is inside a colored bubble
 *
 *  SLOTS:
 *  - default: label content
 */
export default {
  props: {
    // Icon to use - required
    icon: {
      type: String,
      required: true
    },
    // size of btn
    size: {
      type: String,
      default: 'md'
    },
    // label to display (or use default slot)
    label: {
      type: String
    },
    // color of the icon bubble
    bubbleColor: {
      type: String
    },
    // color of the icon text
    iconColor: {
      type: String
    },
    // show a separate on the right of this element
    // Will only display if another button exists next to this element
    separator: {
      type: Boolean,
      default: false
    },
    // render the icon in a larger circle with a smaller centered icon
    bubble: {
      type: Boolean,
      default: false
    }
  }
}
</script>
